import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import MaterialButton from '@material-ui/core/Button';

import { translate } from 'services/i18nService';
import Modal from 'components/Modal/Modal';

import NoFlashIcon from '../../../images/no-flash.svg';

import styles from './Safari14Modal.css';


function Safari14Modal({ show, close }) {
  return (
    <Modal className={styles.modalWidth} close={close} show={show} showClose={false} size="small" type="full">
      <div className={styles.content}>
        <img alt="token icon" className={styles.warning} src={NoFlashIcon} />
        <Fragment>
          <h3 className={styles.title}>{translate('v2profile.flash.not.supported')}</h3>
          <p className={styles.text}>{translate('v2profile.flash.not.supported.paragraph')}</p>
        </Fragment>
        <Fragment>
          <p className={styles.text}>{translate('v2profile.flash.not.supported.other.browser')}</p>
          <a className={styles.link} href="https://www.google.com/chrome" rel="noreferrer" target="_blank">
            {translate('v2profile.flash.not.supported.download.chrome')}
          </a>
        </Fragment>
      </div>
      <div className={styles.footer}>
        <MaterialButton classes={{ root: styles.footerCta }} onClick={close}>
          {translate('v2profile.button.cancel')}
        </MaterialButton>
      </div>
    </Modal>
  );
}

Safari14Modal.propTypes = {
  close: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

export default Safari14Modal;
